<div class="actions-row pe-5">
  <base-button
    [size]="buttonSizes.sm"
    *ngIf="isOfferConfirmed"
    color="dark"
    label="operations.to"
    class="small-padding"
    (btnClick)="openAssignmentsInfo()"
  ></base-button>

  <base-button
    [size]="buttonSizes.sm"
    *ngIf="isOfferOpen"
    color="secondary"
    [label]="isShiftsDeselectionMode ? 'inquiry.deselectAll' : 'inquiry.selectAll'"
    class="small-padding"
    (btnClick)="allShiftsSelection()"
  ></base-button>

  <base-button
    color="secondary"
    class="small-padding"
    *ngIf="isRejectButtonAvailable || isWithdrawButtonAvailable"
    [label]="isOfferOpen ? 'inquiry.rejectOffer' : 'inquiry.withdrawAndRejectOffer'"
    [size]="buttonSizes.sm"
    (btnClick)="openRejectOfferModal()"
  ></base-button>

  <base-button
    [size]="buttonSizes.sm"
    *ngIf="isPreselectButtonAvailable || isUnselectButtonAvailable"
    [color]="offer.data.preselected ? 'secondary' : 'primary'"
    [label]="offer.data.preselected ? 'inquiry.unselectOffer' : 'inquiry.preselectOffer'"
    class="small-padding"
    [ngClass]="{ 'unselect-offer-button': offer.data.preselected }"
    (btnClick)="handleOfferPreselection()"
  ></base-button>

  <base-button
    [size]="buttonSizes.sm"
    *ngIf="isAcceptButtonAvailable"
    color="dark"
    label="inquiry.acceptOffer"
    class="small-padding"
    [disabled]="!offerPositionsToAccept.length"
    (btnClick)="openAcceptOfferModal()"
  ></base-button>
</div>

<ng-template #rejectOfferTemplate>
  <div
    class="d-flex flex-column gap-4"
    [formGroup]="rejectOfferForm"
    [ngClass]="{ 'was-validated': isRejectFormSubmitted }"
  >
    <span [innerHTML]="'inquiry.rejectOfferConfirmation' | translate: { fullName: profileName }"></span>
    <base-dropdown
      [items]="rejectionCauseList"
      formControlName="decliningCategory"
      [translateItems]="true"
      [searchable]="false"
      [requiredLabel]="true"
      bindOptionLabel="label"
      placeholder="inquiry.rejectReasonPlaceholder"
      baseFieldValidationArgs="rejectReasonRequired"
    >
    </base-dropdown>
    <base-textarea
      formControlName="decliningNote"
      placeholder="inquiry.rejectMessagePlaceholder"
      [isInvalid]="!!rejectOfferForm.get('decliningNote')?.errors"
      [errorMessage]="rejectOfferForm.get('decliningNote')?.errors | baseFieldValidation"
    ></base-textarea>

    <div class="modal-footer pb-3 px-0">
      <base-button
        class="btn-confirm"
        color="secondary"
        label="action.cancel"
        [size]="buttonSizes.md"
        (btnClick)="closeModal()"
      ></base-button>
      <base-button
        class="btn-confirm"
        color="primary"
        label="action.okRefuse"
        [size]="buttonSizes.md"
        (btnClick)="rejectOffer()"
      ></base-button>
    </div>
  </div>
</ng-template>

<ng-template #acceptOfferModal>
  <p
    [innerHTML]="
      'inquiry.acceptOfferConfirmation'
        | translate: { fullName: offer.data.profile.firstName + ' ' + offer.data.profile.lastName }
    "
  ></p>
  <base-expansion-panel
    *ngIf="offer.data.industrySurcharges"
    title="industrySurcharges.plural"
    titleClass="headline-20 mb-0"
  >
    <base-industry-surcharges
      [surcharges]="offer.data.industrySurcharges!"
      [showCategoryAndMethod]="true"
    ></base-industry-surcharges>
  </base-expansion-panel>
</ng-template>
